import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'genderSymbolUtf8',
  standalone: false
})
export class GenderSymbolUtf8Pipe implements PipeTransform {
  transform(value: string, femaleSymbol = 'F', maleSymbol = 'M'): string {
    // eslint-disable-next-line
    value = value?.toString();
    switch (value) {
      case femaleSymbol:
        return '♀';
      case maleSymbol:
        return '♂';
      default:
        return '⚥';
    }
  }
}
